export class AisInstitutionDto {
  id: number
  providerId: number
  code: string
  name: string
  bic: string
  logo: string
  transactionTotalDays: number
  maxAccessValidForDays: number
  disabledDate?: Date
}

export class AisInstitutionResponseDto {
  items: AisInstitutionDto[]
  meta?: {
    totalItems: number
    itemCount: number
    itemsPerPage: number
    totalPages: number
    currentPage: number
  }
  links?: {
    first: number
    previous: number
    next: number
    last: number
  }
}